import styled from "styled-components";

export const UploadListItemStyled = styled.div`

    display: flex;
    padding: 13px 23px;
    justify-content: space-between;
    align-items: center;

    border-bottom: 1px solid var(--bllink-blue);
    &:last-of-type {
      border-bottom: none;
    }
  
    .progress-line {
      flex-basis: 50%;
      color: rgba(55, 54, 71, 0.5);

      .progress-head {
        display: flex;
        justify-content: space-between;

        .file-name {
          color: var(--bllink-gray);
        }
      }

      progress {
        margin: 7px 0 5px;
        display: block;
        width: 100%;
        -webkit-appearance: none;
        appearance: none;
        height: 2px;
        &:not([value]) {
          visibility: hidden;
        }
        &::-webkit-progress-bar {
          background-color: transparent;
          
        }
        &::-webkit-progress-value {
          background-color: var(--bllink-purple);
        }
      }
    }
    .no-progress {
      visibility: hidden;
    }

    .select {
      flex-basis: 30%;
    }

    button.delete {
      cursor: pointer;
      display: inline-block;
      border: none;
      background-color: transparent;
      &[disabled] {
        filter: grayscale(1);
        user-select: none;
        cursor: auto;
      }
    }
`;
